import React, { useContext, useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Container } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Cookies from "universal-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationList,
  logoutAction,
  markNotificationRead,
  userInfo,
} from "../Redux/Actions/auth";
import { toast } from "react-toastify";
import { capitalize, getGreeting } from "../Utils/commonFiles";
import { ChatContext } from "./context/ChatProvider";
import { getEventRequestChange } from "../Redux/Actions/eventData";

const TopHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [message, setMessage] = useState("");
  const [notifications, setNotifications] = useState([]);

  const userData = useSelector((e) => e.userAuth.userList);
  const eventUpcoming = useSelector((e) => e.eventAuth.upcomingEvent);
  const getNotificationlist = useSelector(
    (e) => e.notification.notificationList
  );

  const cookies = new Cookies();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loading, setLoading] = useState(true);
  const {
    events,
    messages,
    sendMessage,
    setConnectionId,
    setEventId,
    messageBottomRef,
    unreadCount,
  } = useContext(ChatContext);

  const isHref = (...paths) => {
    const currentPath = window.location.pathname;
    return paths.some((path) => currentPath.includes(path));
  };

  const getDefaultChatParams = () => {
    if (events?.data?.length > 0) {
      const mostRecentEvent = events.data.reduce((prev, current) => {
        const prevDate = new Date(
          prev.latestMessageCreatedAt || prev.createdAt
        );
        const currDate = new Date(
          current.latestMessageCreatedAt || current.createdAt
        );
        return prevDate > currDate ? prev : current;
      });
      return {
        userId: mostRecentEvent.musician?._id,
        musician: mostRecentEvent.musician?.fullName,
        eventId: mostRecentEvent._id,
      };
    }
    return { userId: "", eventId: "", musician: "" };
  };

  const handleSignOut = async (e) => {
    e.preventDefault();
    await dispatch(logoutAction())
      .then((res) => {
        if (res?.payload?.statusCode === 200) {
          toast.success(res?.payload?.message);
          cookies.remove("userToken");
          sessionStorage.removeItem("userToken");
          sessionStorage.removeItem("isVerified");
          navigate("/");
        }
      })
      .catch((error) => {
        console.error("Logout Error:", error);
      });
  };

  useEffect(() => {
    dispatch(userInfo());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getNotificationList());
  }, [dispatch]);

  const handleMessagesClick = (e) => {
    e.preventDefault();
    setLoading(true);
    const { userId, eventId, musician } = getDefaultChatParams();
    if (userId && eventId) {
      setEventId(eventId);
      setConnectionId(userId);
      navigate(`/messages?user_id=${userId}&event_id=${eventId}&musician=${musician}`);
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };

  const handleRequestChange = async () => {
    const payload = {
      event: eventUpcoming?._id,
      message: message,
    };

    try {
      if (eventUpcoming?._id) {
        const res = await dispatch(getEventRequestChange(payload));
        if (res?.payload?.statusCode === 200) {
          toast.success("Request Sent");
          setMessage("");
          handleClose();
        } else {
          toast.error("Failed to send request");
        }
      }
    } catch (error) {
      toast.error("An error occurred");
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    if (getNotificationlist && getNotificationlist.length > 0) {
      setNotifications(
        getNotificationlist.map((item) => ({
          ...item,
          isRead: item.isRead || false,
        }))
      );
    } else {
      setNotifications([]);
    }
  }, [getNotificationlist]);

  const hasUnreadNotifications = notifications.some(
    (notification) => !notification.isRead
  );

  const markAsRead = (index, id) => {
    const updatedNotifications = [...notifications];

    if (!updatedNotifications[index].isRead) {
      updatedNotifications[index].isRead = true;
      setNotifications(updatedNotifications);
      dispatch(markNotificationRead({ notificationId: id }));
    }
  };

  return (
    <div>
      <div className="comm-header-nav">
        <Navbar collapseOnSelect expand="lg" className="">
          <Container fluid>
            <Navbar.Brand href="/home">
              <img
                src={require("../Assets/Images/side-bar-logo.svg").default} style={{ height: "90px" }} alt="logo"
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mx-auto">
                <Link
                  className={
                    window.location.pathname === "/home"
                      ? "nav-link active"
                      : "nav-link "
                  }
                  to="/home"
                >
                  Dashboard
                </Link>
                <Link
                  className={
                    window.location.pathname === "/about"
                      ? "nav-link active"
                      : "nav-link "
                  }
                  to="/about"
                >
                  About
                </Link>
                <Link
                  // className={
                  //   window.location.pathname == "/song-list"
                  //     ? "nav-link active"
                  //     : "nav-link "
                  // }
                  className={
                    isHref("song-list", "all-songs")
                      ? "nav-link active"
                      : "nav-link"
                  }
                  to="/song-list"
                >
                  Song list
                </Link>
                <Link
                  className={
                    window.location.pathname === "/payments"
                      ? "nav-link active"
                      : "nav-link "
                  }
                  to="/payments"
                >
                  Payments
                </Link>

                <Link
                  className={
                    window.location.pathname === "/messages"
                      ? "nav-link active"
                      : "nav-link "
                  }
                  to="/messages"
                >
                  Messages
                </Link>

                <Link
                  className={
                    window.location.pathname === "/resources"
                      ? "nav-link active"
                      : "nav-link "
                  }
                  to="/resources"
                >
                  Resources
                </Link>
              </Nav>
              <div className="nav-action-side">
                {/* <Link
                  className={
                    window.location.pathname == "/payments"
                      ? "nav-link side-btn-svg active"
                      : "nav-link "
                  }
                  to="/payments"
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      opacity="0.65"
                      cx="20"
                      cy="20"
                      r="19"
                      stroke="#3B5A6A"
                      stroke-width="2"
                    />
                    <path
                      d="M15.3145 27C16.3401 27 17.3467 25.349 17.3467 23.6673C17.3512 23.2184 17.2996 22.7706 17.1929 22.3342L16.7072 21.0011C16.2211 19.9559 15.9767 18.8177 15.9919 17.6683C15.971 17.05 16.0793 16.4341 16.3102 15.8587C16.5411 15.2833 16.8896 14.7607 17.3342 14.3232C17.7787 13.8858 18.3099 13.5429 18.8946 13.3157C19.4794 13.0885 20.1054 12.9819 20.7337 13.0025C21.6271 12.9814 22.5123 13.1751 23.3124 13.5668C23.5519 13.684 23.7816 13.818 23.9999 13.9672M15.3145 27H23.4067M15.3145 27H15.2778"
                      stroke="#979699"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M14 20.6665H22.1289"
                      stroke="#979699"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </Link> */}
                {/* navigate(`/messages?user_id=${currentUserId}&event_id=${currentEventId}`) */}
                {/* <Link
                  className={
                    // window.location.pathname == "/messages"
                    window.location.pathname.includes("/messages")
                      ? "nav-link side-btn-svg-two active"
                      : "nav-link "
                  }
                  // to="/messages"
                  onClick={handleMessagesClick}
                >
                  <div style={{ position: "relative" }}>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        opacity="0.65"
                        cx="20"
                        cy="20"
                        r="19"
                        stroke="#3B5A6A"
                        stroke-width="2"
                      />
                      <g clip-path="url(#clip0_309_141)">
                        <path
                          d="M28.9991 19.4352C28.8907 17.6802 28.271 15.9953 27.2165 14.5883C26.1621 13.1812 24.7189 12.1135 23.0649 11.5167C21.411 10.9199 19.6185 10.8202 17.9086 11.2298C16.1986 11.6394 14.6459 12.5405 13.4419 13.8219C12.2378 15.1033 11.4351 16.7091 11.1326 18.4412C10.8301 20.1733 11.0411 21.9561 11.7396 23.5697C12.4381 25.1834 13.5935 26.5573 15.0635 27.5222C16.5334 28.4872 18.2536 29.0008 20.0119 28.9999H25.2491C26.2434 28.9989 27.1966 28.6035 27.8997 27.9005C28.6027 27.1974 28.9981 26.2442 28.9991 25.2499V19.4352ZM27.4991 25.2499C27.4991 25.8467 27.2621 26.419 26.8401 26.8409C26.4182 27.2629 25.8459 27.4999 25.2491 27.4999H20.0119C18.9536 27.4995 17.9073 27.2759 16.9412 26.8439C15.9751 26.4119 15.1108 25.7811 14.4049 24.9927C13.6955 24.2046 13.1628 23.274 12.8426 22.2633C12.5223 21.2525 12.4218 20.185 12.5479 19.1322C12.747 17.4716 13.493 15.9246 14.6685 14.7349C15.8439 13.5452 17.3819 12.7805 19.0399 12.5614C19.3633 12.5209 19.6889 12.5004 20.0149 12.4999C21.7627 12.4952 23.4565 13.1059 24.7991 14.2249C25.5833 14.8766 26.2269 15.6808 26.691 16.5887C27.1551 17.4965 27.4301 18.4892 27.4991 19.5064V25.2499Z"
                          fill="#979699"
                        />
                        <path
                          d="M16.999 17.75H19.999C20.1979 17.75 20.3887 17.671 20.5294 17.5303C20.67 17.3897 20.749 17.1989 20.749 17C20.749 16.8011 20.67 16.6103 20.5294 16.4697C20.3887 16.329 20.1979 16.25 19.999 16.25H16.999C16.8001 16.25 16.6093 16.329 16.4687 16.4697C16.328 16.6103 16.249 16.8011 16.249 17C16.249 17.1989 16.328 17.3897 16.4687 17.5303C16.6093 17.671 16.8001 17.75 16.999 17.75ZM22.999 19.25H16.999C16.8001 19.25 16.6093 19.329 16.4687 19.4697C16.328 19.6103 16.249 19.8011 16.249 20C16.249 20.1989 16.328 20.3897 16.4687 20.5303C16.6093 20.671 16.8001 20.75 16.999 20.75H22.999C23.1979 20.75 23.3887 20.671 23.5294 20.5303C23.67 20.3897 23.749 20.1989 23.749 20C23.749 19.8011 23.67 19.6103 23.5294 19.4697C23.3887 19.329 23.1979 19.25 22.999 19.25ZM22.999 22.25H16.999C16.8001 22.25 16.6093 22.329 16.4687 22.4697C16.328 22.6103 16.249 22.8011 16.249 23C16.249 23.1989 16.328 23.3897 16.4687 23.5303C16.6093 23.671 16.8001 23.75 16.999 23.75H22.999C23.1979 23.75 23.3887 23.671 23.5294 23.5303C23.67 23.3897 23.749 23.1989 23.749 23C23.749 22.8011 23.67 22.6103 23.5294 22.4697C23.3887 22.329 23.1979 22.25 22.999 22.25Z"
                          fill="#979699"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_309_141">
                          <rect
                            width="18"
                            height="18"
                            fill="white"
                            transform="translate(11 11)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    {unreadCount > 0 && (
                      <span
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "-1px",
                          width: "8px",
                          height: "8px",
                          backgroundColor: "red",
                          borderRadius: "50%",
                        }}
                      />
                    )}
                  </div>
                </Link> */}

                {/* get notofications list */}

                <div className="notify-icon">
                  <div className="notification-icon">
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                        style={{ position: "relative" }}
                      >
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            opacity="0.65"
                            cx="20"
                            cy="20"
                            r="19"
                            stroke="#3B5A6A"
                            stroke-width="2"
                          />
                          <g clip-path="url(#clip0_309_153)">
                            <path
                              d="M27.9133 21.2461L26.4884 16.1197C26.0708 14.6178 25.1632 13.2987 23.9097 12.3719C22.6563 11.4452 21.1291 10.964 19.5708 11.0048C18.0126 11.0457 16.5126 11.6063 15.3095 12.5974C14.1064 13.5886 13.2691 14.9535 12.9308 16.4751L11.8276 21.4358C11.7058 21.9839 11.7086 22.5524 11.8359 23.0993C11.9631 23.6463 12.2116 24.1576 12.563 24.5956C12.9143 25.0336 13.3596 25.3871 13.8658 25.63C14.3721 25.8729 14.9264 25.999 15.488 25.999H16.3234C16.4955 26.8466 16.9553 27.6087 17.625 28.1561C18.2947 28.7034 19.133 29.0024 19.9979 29.0024C20.8629 29.0024 21.7012 28.7034 22.3709 28.1561C23.0405 27.6087 23.5004 26.8466 23.6725 25.999H24.3009C24.879 25.9991 25.4492 25.8655 25.9671 25.6086C26.4849 25.3518 26.9364 24.9788 27.2862 24.5186C27.636 24.0584 27.8747 23.5236 27.9836 22.9559C28.0925 22.3882 28.068 21.803 27.9133 21.2461ZM19.9979 27.4989C19.5343 27.4969 19.0826 27.3518 18.7046 27.0833C18.3266 26.8149 18.0407 26.4362 17.8862 25.999H22.1097C21.9552 26.4362 21.6693 26.8149 21.2913 27.0833C20.9133 27.3518 20.4616 27.4969 19.9979 27.4989ZM26.0917 23.6105C25.8828 23.8878 25.612 24.1124 25.301 24.2667C24.99 24.421 24.6474 24.5006 24.3002 24.4992H15.488C15.1511 24.4991 14.8185 24.4234 14.5148 24.2777C14.2111 24.1319 13.944 23.9198 13.7333 23.657C13.5225 23.3942 13.3735 23.0874 13.2971 22.7593C13.2208 22.4312 13.2191 22.0901 13.2922 21.7613L14.3946 16.7998C14.6603 15.6046 15.318 14.5325 16.263 13.754C17.208 12.9755 18.3861 12.5352 19.6101 12.5031C20.834 12.4711 22.0336 12.8491 23.0181 13.5771C24.0025 14.305 24.7154 15.3412 25.0434 16.5209L26.4682 21.6473C26.5623 21.9813 26.5773 22.3326 26.512 22.6734C26.4466 23.0142 26.3028 23.3351 26.0917 23.6105Z"
                              fill="#979699"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_309_153">
                              <rect
                                width="18"
                                height="18"
                                fill="white"
                                transform="translate(11 11)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        {hasUnreadNotifications && (
                          <div
                            style={{
                              position: "absolute",
                              top: "-5px",
                              right: "-6px",
                              width: "18px",
                              height: "18px",
                              backgroundColor: "red",
                              borderRadius: "50%",
                              border: "1px solid white",
                              color: "white",
                              fontSize: "10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              lineHeight: "8px",
                            }}
                          >
                            {notifications.filter((n) => !n.isRead).length}
                          </div>
                        )}
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="notifiaction">
                        <Dropdown.Item className="">
                          <div className="notify-head">
                            <p>Notifications</p>
                            {hasUnreadNotifications && (
                              <span>
                                {notifications.filter((n) => !n.isRead).length}{" "}
                                New
                              </span>
                            )}
                          </div>
                        </Dropdown.Item>

                        {notifications?.length > 0 ? (
                          notifications.map((item, i) => {
                            if (item?.notificationType === "SongRequest") {
                              return (
                                <Dropdown.Item
                                  className={`drop-pro-view ${!item.isRead ? "notification_active" : ""
                                    }`}
                                  key={i}
                                >
                                  <div
                                    className="drop-pro-view"
                                    onClick={() => {
                                      markAsRead(i, item?._id);
                                      // navigate(
                                      //   `/events-details/${item?.event}?clientId=${item?.client}`
                                      // );
                                    }}
                                  >
                                    <div className="user-notfic-icon">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <g clip-path="url(#clip0_82_8485)">
                                          <path
                                            d="M19.6741 2.75827C18.4071 1.70392 16.9354 0.923427 15.3519 0.465964C13.7683 0.00850183 12.1072 -0.116013 10.4731 0.100265C7.45016 0.492983 4.68998 2.02144 2.75302 4.37527C0.816057 6.72911 -0.152497 9.73188 0.0440236 12.7739C0.240544 15.8159 1.58741 18.6691 3.81114 20.7541C6.03486 22.8392 8.96876 23.9998 12.0171 24.0003H18.9991C20.3247 23.9987 21.5955 23.4714 22.5329 22.534C23.4702 21.5967 23.9975 20.3259 23.9991 19.0003V11.2463C23.8933 9.61171 23.4551 8.01592 22.7115 6.55648C21.9678 5.09704 20.9343 3.80462 19.6741 2.75827ZM7.9991 7.00027H11.9991C12.2643 7.00027 12.5187 7.10562 12.7062 7.29316C12.8937 7.4807 12.9991 7.73505 12.9991 8.00027C12.9991 8.26548 12.8937 8.51984 12.7062 8.70737C12.5187 8.89491 12.2643 9.00027 11.9991 9.00027H7.9991C7.73388 9.00027 7.47953 8.89491 7.29199 8.70737C7.10446 8.51984 6.9991 8.26548 6.9991 8.00027C6.9991 7.73505 7.10446 7.4807 7.29199 7.29316C7.47953 7.10562 7.73388 7.00027 7.9991 7.00027ZM15.9991 17.0003H7.9991C7.73388 17.0003 7.47953 16.8949 7.29199 16.7074C7.10446 16.5198 6.9991 16.2655 6.9991 16.0003C6.9991 15.7351 7.10446 15.4807 7.29199 15.2932C7.47953 15.1056 7.73388 15.0003 7.9991 15.0003H15.9991C16.2643 15.0003 16.5187 15.1056 16.7062 15.2932C16.8937 15.4807 16.9991 15.7351 16.9991 16.0003C16.9991 16.2655 16.8937 16.5198 16.7062 16.7074C16.5187 16.8949 16.2643 17.0003 15.9991 17.0003ZM15.9991 13.0003H7.9991C7.73388 13.0003 7.47953 12.8949 7.29199 12.7074C7.10446 12.5198 6.9991 12.2655 6.9991 12.0003C6.9991 11.7351 7.10446 11.4807 7.29199 11.2932C7.47953 11.1056 7.73388 11.0003 7.9991 11.0003H15.9991C16.2643 11.0003 16.5187 11.1056 16.7062 11.2932C16.8937 11.4807 16.9991 11.7351 16.9991 12.0003C16.9991 12.2655 16.8937 12.5198 16.7062 12.7074C16.5187 12.8949 16.2643 13.0003 15.9991 13.0003Z"
                                            fill="#132027"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_82_8485">
                                            <rect
                                              width="24"
                                              height="24"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                    <div className="notification-box">
                                      <p>{item?.body}</p>
                                    </div>
                                  </div>
                                </Dropdown.Item>
                              );
                            }
                            if (item?.notificationType === "Payment") {
                              return (
                                <Dropdown.Item
                                  className={`drop-pro-view ${!item.isRead ? "notification_active" : ""
                                    }`}
                                  key={i}
                                >
                                  <div
                                    className="drop-pro-view"
                                    onClick={() => {
                                      markAsRead(i, item?._id);
                                      navigate("/transactions");
                                    }}
                                  >
                                    <div className="user-notfic-icon">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <g clip-path="url(#clip0_82_8485)">
                                          <path
                                            d="M19.6741 2.75827C18.4071 1.70392 16.9354 0.923427 15.3519 0.465964C13.7683 0.00850183 12.1072 -0.116013 10.4731 0.100265C7.45016 0.492983 4.68998 2.02144 2.75302 4.37527C0.816057 6.72911 -0.152497 9.73188 0.0440236 12.7739C0.240544 15.8159 1.58741 18.6691 3.81114 20.7541C6.03486 22.8392 8.96876 23.9998 12.0171 24.0003H18.9991C20.3247 23.9987 21.5955 23.4714 22.5329 22.534C23.4702 21.5967 23.9975 20.3259 23.9991 19.0003V11.2463C23.8933 9.61171 23.4551 8.01592 22.7115 6.55648C21.9678 5.09704 20.9343 3.80462 19.6741 2.75827ZM7.9991 7.00027H11.9991C12.2643 7.00027 12.5187 7.10562 12.7062 7.29316C12.8937 7.4807 12.9991 7.73505 12.9991 8.00027C12.9991 8.26548 12.8937 8.51984 12.7062 8.70737C12.5187 8.89491 12.2643 9.00027 11.9991 9.00027H7.9991C7.73388 9.00027 7.47953 8.89491 7.29199 8.70737C7.10446 8.51984 6.9991 8.26548 6.9991 8.00027C6.9991 7.73505 7.10446 7.4807 7.29199 7.29316C7.47953 7.10562 7.73388 7.00027 7.9991 7.00027ZM15.9991 17.0003H7.9991C7.73388 17.0003 7.47953 16.8949 7.29199 16.7074C7.10446 16.5198 6.9991 16.2655 6.9991 16.0003C6.9991 15.7351 7.10446 15.4807 7.29199 15.2932C7.47953 15.1056 7.73388 15.0003 7.9991 15.0003H15.9991C16.2643 15.0003 16.5187 15.1056 16.7062 15.2932C16.8937 15.4807 16.9991 15.7351 16.9991 16.0003C16.9991 16.2655 16.8937 16.5198 16.7062 16.7074C16.5187 16.8949 16.2643 17.0003 15.9991 17.0003ZM15.9991 13.0003H7.9991C7.73388 13.0003 7.47953 12.8949 7.29199 12.7074C7.10446 12.5198 6.9991 12.2655 6.9991 12.0003C6.9991 11.7351 7.10446 11.4807 7.29199 11.2932C7.47953 11.1056 7.73388 11.0003 7.9991 11.0003H15.9991C16.2643 11.0003 16.5187 11.1056 16.7062 11.2932C16.8937 11.4807 16.9991 11.7351 16.9991 12.0003C16.9991 12.2655 16.8937 12.5198 16.7062 12.7074C16.5187 12.8949 16.2643 13.0003 15.9991 13.0003Z"
                                            fill="#132027"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_82_8485">
                                            <rect
                                              width="24"
                                              height="24"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                    <div className="notification-box">
                                      <p>{item?.body}</p>
                                    </div>
                                  </div>
                                </Dropdown.Item>
                              );
                            }
                            return null; // Ignore other notification types
                          })
                        ) : (
                          <Dropdown.Item className="">
                            <div className="drop-pro-view">
                              <div className="user-notfic-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <g clip-path="url(#clip0_82_8485)">
                                    <path
                                      d="M19.6741 2.75827C18.4071 1.70392 16.9354 0.923427 15.3519 0.465964C13.7683 0.00850183 12.1072 -0.116013 10.4731 0.100265C7.45016 0.492983 4.68998 2.02144 2.75302 4.37527C0.816057 6.72911 -0.152497 9.73188 0.0440236 12.7739C0.240544 15.8159 1.58741 18.6691 3.81114 20.7541C6.03486 22.8392 8.96876 23.9998 12.0171 24.0003H18.9991C20.3247 23.9987 21.5955 23.4714 22.5329 22.534C23.4702 21.5967 23.9975 20.3259 23.9991 19.0003V11.2463C23.8933 9.61171 23.4551 8.01592 22.7115 6.55648C21.9678 5.09704 20.9343 3.80462 19.6741 2.75827ZM7.9991 7.00027H11.9991C12.2643 7.00027 12.5187 7.10562 12.7062 7.29316C12.8937 7.4807 12.9991 7.73505 12.9991 8.00027C12.9991 8.26548 12.8937 8.51984 12.7062 8.70737C12.5187 8.89491 12.2643 9.00027 11.9991 9.00027H7.9991C7.73388 9.00027 7.47953 8.89491 7.29199 8.70737C7.10446 8.51984 6.9991 8.26548 6.9991 8.00027C6.9991 7.73505 7.10446 7.4807 7.29199 7.29316C7.47953 7.10562 7.73388 7.00027 7.9991 7.00027ZM15.9991 17.0003H7.9991C7.73388 17.0003 7.47953 16.8949 7.29199 16.7074C7.10446 16.5198 6.9991 16.2655 6.9991 16.0003C6.9991 15.7351 7.10446 15.4807 7.29199 15.2932C7.47953 15.1056 7.73388 15.0003 7.9991 15.0003H15.9991C16.2643 15.0003 16.5187 15.1056 16.7062 15.2932C16.8937 15.4807 16.9991 15.7351 16.9991 16.0003C16.9991 16.2655 16.8937 16.5198 16.7062 16.7074C16.5187 16.8949 16.2643 17.0003 15.9991 17.0003ZM15.9991 13.0003H7.9991C7.73388 13.0003 7.47953 12.8949 7.29199 12.7074C7.10446 12.5198 6.9991 12.2655 6.9991 12.0003C6.9991 11.7351 7.10446 11.4807 7.2919911.2932C7.47953 11.1056 7.73388 11.0003 7.9991 11.0003H15.9991C16.2643 11.0003 16.5187 11.1056 16.7062 11.2932C16.8937 11.4807 16.9991 11.7351 16.9991 12.0003C16.9991 12.2655 16.8937 12.5198 16.7062 12.7074C16.5187 12.8949 16.2643 13.0003 15.9991 13.0003Z"
                                      fill="#132027"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_82_8485">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </div>
                              <div className="notification-box">
                                <p>No Notifications</p>
                              </div>
                            </div>
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>

                <div className="user-img-top">
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <div className="drop-pro-view align-items-center">
                        <img
                          width={40}
                          height={40}
                          className="rounded-5"
                          src={require("../Assets/Images/user-placeholder.png")}
                        />
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div className="my-profile">
                        <Dropdown.Item>
                          <button
                            onClick={handleShow}
                            className="text-decoration-none"
                          >
                            Request a change
                          </button>
                        </Dropdown.Item>
                      </div>
                      <Dropdown.Divider />
                      <div
                        className="my-profile"
                        onClick={() => navigate("/changepassword")}
                      >
                        <Dropdown.Item className="text-decoration-none">
                          Update password
                        </Dropdown.Item>
                      </div>
                      <Dropdown.Divider />
                      <div className="my-profile">
                        <Dropdown.Item
                          onClick={handleSignOut}
                          className="text-danger"
                        >
                          Logout
                        </Dropdown.Item>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {location.pathname == "/home" && (
          <div className="home-welcome-txt">
            <h2>
              {getGreeting()}, {capitalize(userData?.fullName)}
            </h2>
            <div>
              <button
                className="white-bg"
                onClick={() => navigate("/song-list")}
              >
                Update Song Choices
              </button>
              <button
                className="color-bg"
                onClick={() => navigate("/payments")}
              >
                Pay Balance
              </button>
            </div>
          </div>
        )}
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="border-none justify-content-center">
          <Modal.Title className="mt-3">Request a change</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <div>
            <Form>
              <div className="modal-cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Type your text here"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </Form.Group>
              </div>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-none justify-content-center">
          <button className="secondary" onClick={handleClose}>
            Close
          </button>
          <button className="primary" onClick={handleRequestChange}>
            Request
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TopHeader;
